module.exports = __webpack_public_path__ + "img/產品資訊_產品單圖-07_2023.9cfb6d14.png";